export const accordian = (state = {}, action) => {
  switch (action.type) {
    case 'SET_ACCORDIAN':
      return action.payload.accordian;
    default:
      return state;
  }
};

export const accordiansOpen = (state = [], action) => {
  switch (action.type) {
    case 'OPEN_ACCORDIAN':
      return [...state, action.payload.index];
    case 'CLOSE_ACCORDIAN':
      return state.filter((i) => i !== action.payload.index);
    default:
      return state;
  }
};
